import badge20 from 'assets/images/20_badge.png';
import badge25 from 'assets/images/25_badge.png';
import badge50 from 'assets/images/50_badge.png';

import badgeNone from 'assets/images/none_badge.png';
import badgeBronze from 'assets/images/bronze_badge.png';
import badgeSilver from 'assets/images/silver_badge.png';
import badgeGolden from 'assets/images/golden_badge.png';

const exports = {
  badge20,
  badge25,
  badge50,
  tierBadges: [badgeBronze, badgeSilver, badgeGolden],
};

export default exports;
